<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        @click="openCreateModal"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Добавить мероприятие</vs-button
      >
    </vs-row>
    <vx-card :title="`Список мероприятий | Всего ${totalEvents}`" class="p-6">
      <vs-table
        :data="events"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Даты </vs-th>
          <vs-th> Мероприятие </vs-th>
          <vs-th> Количество участников </vs-th>
          <vs-th> Цена </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="mb-3">
                Дата и время:
                <span class="text-primary">{{
                  formatISODate(data[indextr].date)
                }}</span
                >,
                <span class="text-primary"
                  >{{ data[indextr].date_start }} -
                  {{ data[indextr].date_end }}</span
                >
              </p>
            </vs-td>

            <vs-td>
              <p class="mb-3">
                Категория:
                <span class="text-primary">{{
                  data[indextr].category.name
                }}</span>
              </p>
              <p class="mb-3">
                Название:
                <span class="text-primary">{{ data[indextr].name }}</span>
              </p>
              <p class="mb-3">
                Описание мероприятия:
                <span class="text-primary">{{
                  data[indextr].description
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              <p class="mb-3">
                Максимум:
                <span class="text-primary">{{
                  data[indextr].max_participants
                }}</span>
              </p>
              <p class="mb-3">
                Минимум:
                <span class="text-primary">{{
                  data[indextr].min_participants
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].price }}
            </vs-td>

            <vs-td>
              <vx-tooltip
                class="inline-block mr-5"
                text="Редактировать мероприятие"
              >
                <vs-button
                  @click="openEdit(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip class="inline-block" text="Удалить мероприятие">
                <vs-button
                  @click="deleteEvent(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup title="Создание мероприятия" :active.sync="activeCreatePrompt">
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Название"
          name="Название"
          v-model="newEvent.name"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Название")
        }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Описание мероприятия"
          name="Описание мероприятия"
          v-model="newEvent.description"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Описание мероприятия")
        }}</span>

        <label class="vs-input--label">Дата</label>
        <flat-pickr
          class="block w-full"
          :config="configMultipleDate"
          v-model="newEvent.date"
        />
        <span class="block text-danger text-sm">{{
          errors.first("Дата")
        }}</span>

        <div class="mb-4">
          <label class="vs-input--label">Время начала</label>
          <flat-pickr
            class="block w-full"
            :config="configdateTimePicker"
            v-model="newEvent.dateStart"
          />
        </div>

        <div class="mb-4">
          <label class="vs-input--label">Время окончания</label>
          <flat-pickr
            class="block w-full"
            :config="configdateTimePicker"
            v-model="newEvent.dateEnd"
          />
        </div>
        <span class="block text-danger text-sm" v-if="timeErrorNewEvent"
          ><b>Время начала</b> не должно быть больше или равно
          <b>Время окончания</b></span
        >

        <label for="" class="vs-input--label">Категория</label>
        <v-select
          label="name"
          :reduce="(name) => name.id"
          :clearable="false"
          :options="categories"
          v-model="newEvent.idCategory"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Цена"
          name="Цена"
          v-model.number="newEvent.price"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Цена")
        }}</span>

        <vs-row class="mt-4 justify-between">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
            vs-w="6"
            vs-sm="12"
            class="px-0 -mx-0 sm:-mx-2 sm:px-2"
          >
            <vs-input
              class="w-full mb-4"
              v-validate="'required'"
              data-vv-validate-on="blur"
              label="Максимальное кол-во посетителей"
              name="Максимальное кол-во посетителей"
              v-model.number="newEvent.max"
            />
            <span class="text-danger block text-sm">{{
              errors.first("Максимальное кол-во посетителей")
            }}</span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
            vs-w="6"
            vs-sm="12"
            class="px-0 -mx-0 sm:-mx-2 sm:px-2"
          >
            <vs-input
              class="w-full mb-4"
              v-validate="'required'"
              data-vv-validate-on="blur"
              label="Минимальное кол-во посетителей"
              name="Минимальное кол-во посетителей"
              v-model.number="newEvent.min"
            />
            <span class="text-danger block text-sm">{{
              errors.first("Минимальное кол-во посетителей")
            }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2 mb-3 sm:mb-0">
            <label class="vs-input--label">Цвет фона: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="newEvent.background_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2 mb-3 sm:mb-0">
            <label class="vs-input--label">Цвет времени: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="newEvent.time_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2">
            <label class="vs-input--label">Цвет заголовка: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="newEvent.name_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2">
            <label class="vs-input--label">Цвет стрелки: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="newEvent.arrow_color"
            />
          </vs-col>
        </vs-row>

        <div class="popup-footer mt-4">
          <vs-button
            @click="createEvent"
            :disabled="validateTimeNewEvent"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Создать</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      v-if="editEvent != null"
      title="Редактирование мероприятия"
      :active.sync="activeEditPrompt"
    >
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Название"
          name="Название"
          v-model="editEvent.name"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Название")
        }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Описание мероприятия"
          name="Описание мероприятия"
          v-model="editEvent.description"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Описание мероприятия")
        }}</span>

        <label class="vs-input--label">Дата</label>
        <flat-pickr
          class="block w-full"
          :config="configEditDate"
          v-model="editEvent.date"
        />
        <span class="block text-danger text-sm">{{
          errors.first("Дата")
        }}</span>

        <div class="mb-4">
          <label class="vs-input--label">Время начала</label>
          <flat-pickr
            class="block w-full"
            :config="configEditTime"
            v-model="editEvent.date_start"
          />
        </div>

        <div class="mb-4">
          <label class="vs-input--label">Время окончания</label>
          <flat-pickr
            class="block w-full"
            :config="configEditTime"
            v-model="editEvent.date_end"
          />
          <span class="block text-danger text-sm" v-if="timeErrorEditEvent"
            ><b>Время начала</b> не должно быть больше или равно
            <b>Время окончания</b></span
          >
        </div>

        <label for="" class="vs-input--label">Категория</label>
        <v-select
          label="name"
          :reduce="(name) => name.id"
          :clearable="false"
          :options="categories"
          v-model="editEvent.category"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Цена"
          name="Цена"
          v-model.number="editEvent.price"
        />
        <span class="text-danger block text-sm">{{
          errors.first("Цена")
        }}</span>

        <vs-row class="mt-4 justify-between">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
            vs-w="6"
            vs-sm="12"
            class="px-0 -mx-0 sm:-mx-2 sm:px-2"
          >
            <vs-input
              class="w-full mb-4"
              v-validate="'required'"
              data-vv-validate-on="blur"
              label="Максимальное кол-во посетителей"
              name="Максимальное кол-во посетителей"
              v-model.number="editEvent.max_participants"
            />
            <span class="text-danger block text-sm">{{
              errors.first("Максимальное кол-во посетителей")
            }}</span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
            vs-w="6"
            vs-sm="12"
            class="px-0 -mx-0 sm:-mx-2 sm:px-2"
          >
            <vs-input
              class="w-full mb-4"
              v-validate="'required'"
              data-vv-validate-on="blur"
              label="Минимальное кол-во посетителей"
              name="Минимальное кол-во посетителей"
              v-model.number="editEvent.min_participants"
            />
            <span class="text-danger block text-sm">{{
              errors.first("Минимальное кол-во посетителей")
            }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2 mb-3 sm:mb-0">
            <label class="vs-input--label">Цвет фона: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="editEvent.background_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2 mb-3 sm:mb-0">
            <label class="vs-input--label">Цвет времени: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="editEvent.time_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2">
            <label class="vs-input--label">Цвет заголовка: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="editEvent.name_color"
            />
          </vs-col>

          <vs-col vs-w="3" vs-sm="6" class="px-0 sm:px-2">
            <label class="vs-input--label">Цвет стрелки: </label>
            <input
              class="block border-0 rounded-full w-12 h-12"
              type="color"
              v-model="editEvent.arrow_color"
            />
          </vs-col>
        </vs-row>

        <div class="popup-footer mt-4">
          <vs-button
            :disabled="validateTimeEditEvent"
            @click="updateEvent"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Обновить</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { API_URL } from "@/.env";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    disabledDates: {
      to: ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date()),
    },

    configdateTimePicker: {
      enableTime: true,
      dateFormat: "H:i:ss",
      noCalendar: true,
      time_24hr: true,
      locale: RussianLocale,
    },

    configMultipleDate: {
      mode: "multiple",
      dateFormat: "Y-m-d",
      locale: RussianLocale,

      altInput: true,
      altFormat: "d.m.Y",
    },
    configEditDate: {
      dateFormat: "Y-m-d",
      locale: RussianLocale,

      altInput: true,
      altFormat: "d.m.Y",
    },
    configEditTime: {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,

      dateFormat: "H:i:ss",
      locale: RussianLocale,

      altInput: true,
      altFormat: "H:i",
    },
    events: [],
    categories: [],

    currentPagingationPage: 1,
    totalEvents: 0,
    totalPagePagination: 1,
    countElements: 20,

    activeCreatePrompt: false,
    newEvent: {
      name: "",
      description: "",
      date: "",
      idCategory: 0,
      price: 0,
      dateStart: "",
      dateEnd: "",
      max: 1,
      min: 1,
      background_color: "#8276f4",
      time_color: "#F2F2F2",
      name_color: "#FFFFFF",
      arrow_color: "#FFFFFF",
    },

    activeEditPrompt: false,
    editEvent: null,
    timeErrorNewEvent: false,
    timeErrorEditEvent: false,
  }),
  components: {
    flatPickr,
    DateTime,
  },
  watch: {
    currentPagingationPage: function () {
      this.getEvents();
    },
  },
  computed: {
    validateTimeNewEvent() {
      if (this.newEvent.dateStart && this.newEvent.dateEnd) {
        let splitStart = this.newEvent.dateStart.split(":"),
          splitEnd = this.newEvent.dateEnd.split(":"),
          startTime = new Date().setHours(splitStart[0], splitStart[1]),
          endTime = new Date().setHours(splitEnd[0], splitEnd[1]);

        if (startTime >= endTime) {
          this.timeErrorNewEvent = true;
          return true;
        } else {
          this.timeErrorNewEvent = false;
          return false;
        }
      }
    },
    validateTimeEditEvent() {
      if (this.editEvent.date_start && this.editEvent.date_end) {
        let splitStart = this.editEvent.date_start.split(":"),
          splitEnd = this.editEvent.date_end.split(":"),
          startTime = new Date().setHours(splitStart[0], splitStart[1]),
          endTime = new Date().setHours(splitEnd[0], splitEnd[1]);

        if (startTime >= endTime) {
          this.timeErrorEditEvent = true;
          return true;
        } else {
          this.timeErrorEditEvent = false;
          return false;
        }
      }
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatISODateTime(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT);
    },
    formatISODate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
    },
    getEvents() {
      let payload = {};

      payload.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;

      this.$load(async () => {
        let res = (await this.$api.booking.getEvents(payload)).data;

        this.totalEvents = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalEvents / this.countElements
        );

        this.events = res.results;
      });
    },
    createEvent() {
      let payload = {
        name: this.newEvent.name,
        description: this.newEvent.description,
        date: this.newEvent.date.split(", "),
        idCategory: this.newEvent.idCategory,
        price: this.newEvent.price,

        dateStart: this.newEvent.dateStart,
        dateEnd: this.newEvent.dateEnd,

        max: this.newEvent.max,
        min: this.newEvent.min,
        background_color: this.newEvent.background_color,
        time_color: this.newEvent.time_color,
        name_color: this.newEvent.name_color,
        arrow_color: this.newEvent.arrow_color,
      };

      this.$load(async () => {
        let res = (await this.$api.booking.createEvent(payload)).data;

        res.forEach((event) => {
          this.events.splice(0, 0, event);
        });

        this.notification("Успешно", "Мероприятие создано", "success");

        this.activeCreatePrompt = false;
      });
    },
    openCreateModal() {
      if (!this.categories.length) {
        this.getCategories();
      }

      this.activeCreatePrompt = true;
    },
    getCategories() {
      this.$load(async () => {
        let res = (await this.$api.booking.getCategories({ limit: 100 })).data;

        this.categories = res.results;
      });
    },
    deleteEvent(idEvent) {
      let item = this.events.find((x) => x.id == idEvent),
        index = this.events.indexOf(item);

      this.$load(async () => {
        let res = (await this.$api.booking.deleteEvent(idEvent)).data;

        if (index !== -1) {
          this.events.splice(index, 1);
        }

        this.notification("Успешно", "Мероприятие удалено", "success");
      });
    },
    openEdit(idEdent) {
      if (!this.categories.length) {
        this.getCategories();
      }
      let event = this.events.find((x) => x.id == idEdent);

      this.editEvent = event;
      this.activeEditPrompt = true;
    },
    updateEvent() {
      let payload = {
        name: this.editEvent.name,
        description: this.editEvent.description,
        date: this.editEvent.date,
        idCategory: this.editEvent.category.id,
        price: this.editEvent.price,
        dateStart: this.editEvent.date_start,
        dateEnd: this.editEvent.date_end,
        max: this.editEvent.max_participants,
        min: this.editEvent.min_participants,
        background_color: this.editEvent.background_color,
        time_color: this.editEvent.time_color,
        name_color: this.editEvent.name_color,
        arrow_color: this.editEvent.arrow_color,
      };

      this.$load(async () => {
        await this.$api.booking
          .updateEvent(this.editEvent.id, payload)
          .then((response) => {
            this.notification("Успешно", "Мероприятие обновлено", "success");
            this.activeEditPrompt = false;
          });
      });
    },
  },
  created() {},
  mounted() {
    this.getEvents();
  },
};
</script>